import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PatternFormat } from 'react-number-format';
import CreditCards from './CreditCards';
import { InsetWrapper } from '../../CheckoutProcess/components/InsetWrapper';
import { CheckoutProcessContext } from '../../CheckoutProcess/contexts/CheckoutProcessContext';
import { ShippingAddress } from '../../CheckoutProcess/components/fields/ShippingAddress';

export class ShowclixCreditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      number: '',
      expMonth: '',
      expYear: '',
      ccv: '',
      zip: '',
      useDeliveryAddress: true,
      address: {
        name: this.props.name,
        address: this.props.defaultAddress.address,
        address2: this.props.defaultAddress.address2,
        city: this.props.defaultAddress.city,
        state: this.props.defaultAddress.state,
        country: this.props.defaultAddress.country,
        zip: this.props.defaultAddress.zip,
        phone: this.props.phone,
      },
      loading: false,
    };
    this.sectionRef = React.createRef();
  }

  onNumberChange = (e) => {
    this.setState({ number: e.target.value });
  };

  onMonthChange = (e) => {
    this.setState({ expMonth: e.target.value });
  };

  onYearChange = (e) => {
    this.setState({ expYear: e.target.value });
  };

  onCCVChange = (e) => {
    this.setState({ ccv: e.target.value });
  };

  onZipChange = (e) => {
    let address = { ...this.state.address };
    address.zip = e.target.value;
    this.setState({ zip: e.target.value, address });
  };

  onAddressChange = (address) => {
    this.setState({ address });
  };

  onUseDeliveryAddressChange = () => {
    this.setState({
      useDeliveryAddress: !this.state.useDeliveryAddress,
    });
  };

  onSuccess = () => {
    this.setState({ loading: false });
  };

  onError = () => {
    this.setState({ loading: false });
  };

  submitPayment = async (e, t) => {
    e.preventDefault();
    if (this.state.loading === true) {
      return;
    } else {
      this.setState({ loading: true });
    }

    if (this.props.isFullyPaid) {
      return;
    }

    this.props.onPaymentInitiated();

    let cardNumber = this.state.number.replace(/\s+/g, '');
    let payload = {
      name: this.state.address.name,
      number: cardNumber,
      expiration_month: this.state.expMonth,
      expiration_year: this.state.expYear,
      security_code: this.state.ccv,
      ...this.state.address,
      amount: this.props.amount,
      email: this.props.email,
      tos_accepted: this.props.tosAccepted,
      captureMethod: this.props.captureMethod,
      emailOptOut: this.props.emailOptOut,
      leapOptIn: this.props.leapOptIn,
      is_phone_required: this.props.isPhoneRequired
    };

    if (this.props.createdNewAccount) {
      payload.sendAccountEmail = 1;
    }

    if (this.state.useDeliveryAddress) {
      this.props.setDeliveryAddress({ ...this.state.address });
    }

    if (!(await this.props.validateAndSaveDeliveryAddress(t))) {
      this.setState({ loading: false });
      return;
    }

    this.props.onPaymentSubmit(payload, {
      onSuccess: this.onSuccess,
      onError: this.onError,
    });
  };

  renderDeliveryAddress() {
    if (this.props.deliveryOption.method_name === 'Mail' || this.props.hasDeliverableProducts) {
      return (
        <ShippingAddress
          address={this.props.deliveryAddress}
          onAddressChange={this.props.setDeliveryAddress}
          useShippingAddress={this.state.useDeliveryAddress}
          onUseShippingAddressChange={this.onUseDeliveryAddressChange}
        />
      );
    }

    return null;
  }

  componentDidMount() {
    this.sectionRef.current.querySelector('input[value=""]').focus();
  }

  render() {
    return (
      <section className="checkout-form__section checkout-form__section--sc-card" ref={this.sectionRef}>
        <div className="form-card">
          <div className="form-card__header">
            <div className="flex-left">
              <h4 className="form-card__heading">{this.props.t.t('checkout__credit_card_details')}</h4>
            </div>
            <div className="flex-right">
              <CreditCards acceptedCards={this.props.acceptedCards} />
            </div>
          </div>

          <form className="form-card__content" id="payment-submit-form" onSubmit={(e) => this.submitPayment(e, this.props.t)}>
            <InsetWrapper>
              <div className="input__top">
                <label className="input__label" htmlFor="card__input-number">
                  {this.props.t.t('checkout__card_number')}
                </label>
              </div>
              <PatternFormat
                format="#### #### #### ####"
                type="tel"
                id="card__input-number"
                required
                className="input__control card__input card__input-number"
                placeholder="Card Number"
                pattern="[0-9 ]{14,23}"
                autoComplete="cc-number"
                name="number"
                value={this.state.number}
                onChange={this.onNumberChange}
              />
            </InsetWrapper>
            <div className="row card__input-group">
              <div className="col-sm-6">
                <div className="card__input-date-group">
                  {/* <label htmlFor="exp" className="input__label">Expiration Date</label> */}
                  <div className="card__input-date">
                    <div className="card__input-month">
                      <InsetWrapper>
                        <label htmlFor="card__input-month" className="input__label">
                          MM
                        </label>
                        <input
                          type="tel"
                          id="card__input-month"
                          required
                          className=" input__control card__input"
                          placeholder="MM"
                          pattern="[0-9]{1,2}"
                          autoComplete="cc-exp-month"
                          name="expiration_month"
                          value={this.state.expMonth}
                          onChange={this.onMonthChange}
                          maxLength="2"
                        />
                      </InsetWrapper>
                    </div>
                    <span className="card__date-text"> / </span>
                    <div className="card__input-year">
                      <InsetWrapper>
                        <label htmlFor="card__input-year" className="input__label">
                          YYYY
                        </label>
                        <input
                          type="tel"
                          id="card__input-year"
                          required
                          className="input__control card__input card__input-date"
                          placeholder="YYYY"
                          pattern="[0-9]{2,4}"
                          autoComplete="cc-exp-year"
                          name="expiration_year"
                          value={this.state.expYear}
                          onChange={this.onYearChange}
                          maxLength="4"
                        />
                      </InsetWrapper>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input card__input-cvc">
                  <InsetWrapper>
                    <label className="input__label" htmlFor="card__input-cvc">
                      {this.props.t.t('checkout__cvc_code')}
                    </label>
                    <input
                      type="tel"
                      id="card__input-cvc"
                      required
                      className="input__control card__input card__input_cvc"
                      placeholder="CVC Code"
                      autoComplete="cc-cvc"
                      name="security_code"
                      value={this.state.ccv}
                      maxLength="4"
                      inputMode="numeric"
                      pattern="[0-9]{3,4}"
                      onChange={this.onCCVChange}
                    />
                  </InsetWrapper>
                </div>
              </div>
            </div>
            <button style={{ display: 'none' }} id="payment-form-invisible-button" type="submit">
              Invisible display button
            </button>

            <CheckoutProcessContext.Consumer>
                {({ LocalizedAddress }) => (
                <LocalizedAddress
                    {...this.state.address}
                    onAddressChange={this.onAddressChange}
                    header={this.props.t.t('checkout__billing_address')}
                />
                )}
            </CheckoutProcessContext.Consumer>
            {this.renderDeliveryAddress()}
          </form>
        </div>
      </section>
    );
  }
}

ShowclixCreditCard.propTypes = {
  onPaymentInitiated: PropTypes.func.isRequired,
  onPaymentSuccess: PropTypes.func.isRequired,
  onPaymentFail: PropTypes.func.isRequired,
  amount: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string,
  phone: PropTypes.string,
  token: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  tosAccepted: PropTypes.bool.isRequired,
  acceptedCards: PropTypes.object,
  captureMethod: PropTypes.number,
  isFullyPaid: PropTypes.bool,
  createdNewAccount: PropTypes.bool,
  emailOptOut: PropTypes.bool,
  leapOptIn: PropTypes.bool,
  validateAndSaveDeliveryAddress: PropTypes.func.isRequired,
  setDeliveryAddress: PropTypes.func.isRequired,
  deliveryAddress: PropTypes.object.isRequired,
  deliveryOption: PropTypes.object,
  t: PropTypes.object.isRequired,
  defaultAddress: PropTypes.object.isRequired,
  isPhoneRequired: PropTypes.bool
};

ShowclixCreditCard.defaultProps = {
  phone: '',
  name: '',
  acceptedCards: {},
  captureMethod: 1, // CAPTURE_ONLINE
  defaultAddress: {},
};

export default ShowclixCreditCard;
